export  const fetchpermissionhours = `
      

    query PermissionRequestByUserId($userid: ID!){ 

  permissionsByUser(userId: $userid){ 

    data{ 

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 

    status 
    balanceHours

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
     
     
     `;

     //Create api
export const addmutation = `
     
 mutation CreatePermission($input: CreatePermissionInput!) { 

  createPermission(input: $input) { 

    permission { 

      id 

      user { 

        id 

        empid 

        firstName 

      } 

      permissionOn 

      permissionFrom 

      permissionTill 

      reason 

      status 

      teamApproval 

      hrApproval 

      balanceHours 

      createdAt 

    } 

    balanceHours 

    message 

    success 

    error 

  } 

} 
     
     `;
     //Update api
export const updatemutation = `
       
 mutation UpdatePermission(  

  $permissionId: ID!,   

  $permissionOn: Date,   

  $permissionFrom: Time,   

  $permissionTill: Time,   

  $reason: String  

) {  

  updatePermission(  

    permissionId: $permissionId,   

    permissionOn: $permissionOn,   

    permissionFrom: $permissionFrom,   

    permissionTill: $permissionTill,   

    reason: $reason  

  ) {  

    permission {  

      id  

      permissionOn  

      permissionFrom  

      permissionTill  

      reason  

      balanceHours  

      status  

    }  

    balanceHours  

    message  

    success  

    error  

  }  

} 
     
     
     `;